import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
// import "../Profile.css";

import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import CustomCanvasConfetti from "../../../UI/Confetti";
import { createRazorpayLinkedAccTempEntry, getAllBusinessTypes } from "../../../../store/actions/CreateApp/getAllBusinessTypes";
import { userAddNewPassword } from "../../../../api";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const AddBankDetails= ({currentBusinessTypeVal,setNextStep})=>{
    // const {category} = useParams();
      const [animate, setAnimate] = useState(false);
     const [currentBusinessType, setCurrentBusinessType] = useState(currentBusinessTypeVal);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
  
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
       
        const [fireConfetti, setFireConfetti] = useState(false);
       
        const [businessName, setBusinessName] = useState("");
        const [bankAccNumber, setBankAccountNo] = useState("");
        const [bankAccIFSC, setBankIFSC] = useState("");
        const [userName, setUserName] = useState("");
        const [panNo, setPanNo] = useState("");
        const [gstNo, setGstNo] = useState("");
        const [userEmail, setUserEmail] = useState();
         const [businessTypeCode, setBusinessTypeCode] = useState(currentBusinessType?.code_name);
        
      
    const userdata = useSelector((state)=>state?.user?.user);
    useEffect(()=>{
      fireGetAccountDetails()
     
     },[])
  const [itemArr, setItemArr] = useState([]);
                        
                      useEffect(()=>{
                      fireGetAllCoursesByApp();
                     },[])

                     function getBusinessTypeObject(itemArr,businessTypeCode) {
  return itemArr.find(item => item.code_name ===businessTypeCode) || null;
}

    useEffect(()=>{

        if(!currentBusinessTypeVal?.code_name){ setCurrentBusinessType(getBusinessTypeObject(itemArr,businessTypeCode))   ;}
                   

                     },[itemArr])


  const fireGetAllCoursesByApp=()=>{
          setItemArr([])
          
              const apiData = dispatch(getAllBusinessTypes({}));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
                if(response?.business_types){
                   setItemArr(response?.business_types)
                }else{
            //        //popup of error Info
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
                  
            // setSnackbarVisible(true);
            // setTimeout(()=>{
              
            //   setSnackbarVisible(false);
             
               
            // },3000)
                }
       
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
                
                 
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

         
        const flattenedData = itemArr!=[]?Object.values(itemArr):'';

        

     const fireGetAccountDetails=()=>{
      setLoader({status:true});
          
            const apiData = dispatch(createRazorpayLinkedAccTempEntry({businessName:businessName,bankAccNumber:bankAccNumber,
              bankAccIFSC:bankAccIFSC,userEmail:userEmail?userEmail:user_email,
              bankAccHolderName:userName,
              editType:"getAccDataByuserId",panNumber:panNo,gstNumber:gstNo,businessTypeCode:businessTypeCode
              }));
            /* get response as Promise   */
            apiData.then(response => {
              if(response){  
             
                if(response?.accData){
                  
              setResponseMessage(response?.message);
              setSnackbarColor("rgba(144, 202, 249,1)");
              setUserName(response?.accData?.account_holder_name)
              setBankIFSC(response?.accData?.bank_account_ifsc)
              setBankAccountNo(response?.accData?.bank_account_number)
              setBusinessName(response?.accData?.business_name)
              setPanNo(response?.accData?.pan_number)
              setGstNo(response?.accData?.gst_number)
              setUserEmail(response?.accData?.contact_email)
              setBusinessTypeCode(response?.accData?.business_type_code)
            
          setLoader({status:false});
             }else{
        //       setResponseMessage("Something Went Wrong...");
                
        //       setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
        //   setSnackbarVisible(true);
        //   setTimeout(()=>{
            
        //     setSnackbarVisible(false);
           
             
        //   },3000)
             }
                
             
             if(response?.logout){
             
              setResponseMessage("You are Logged Out!!!");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              setTimeout(()=>{
                dispatch({type:"LOGOUT"});
          
              },3000)
              
            }
          /* resetting Login input Fields */
          
              }else{
                setResponseMessage("Something Went Wrong...");
                
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)    }
          
            }).catch(error => {
           
              //popup of error Info
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              console.error(error);
            });
    
       }



     const handleCreateNewAccount=()=>{
      setLoader({status:true});
           if(!businessName){
              setResponseMessage("Business name Required...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)

           }else if(!bankAccNumber){
             
              setResponseMessage("Bank Account Number Required...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
           
           }else if(!bankAccIFSC){
             
              setResponseMessage("Bank IFSC Required...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
           
           }else if(!(user_email?user_email:userEmail)){
             
              setResponseMessage("Account Holder Email Required...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
           
           }else if(!userName){
             
              setResponseMessage("Account Holder Name Required...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
           
           }else {
            const apiData = dispatch(createRazorpayLinkedAccTempEntry({businessName:businessName,bankAccNumber:bankAccNumber,
              bankAccIFSC:bankAccIFSC,userEmail:user_email?user_email:userEmail,
              bankAccHolderName:userName,
              editType:"",panNumber:panNo,gstNumber:gstNo,businessTypeCode:currentBusinessType?.code_name?currentBusinessType?.code_name:businessTypeCode
              }));
            /* get response as Promise   */
            apiData.then(response => {
              if(response){  
               if(response?.userData){
                 dispatch({
            type: "SIGNUP",
               payload:(response?.userData)
          }); 

               }
                if(response?.accData){
                  
              setResponseMessage(response?.message);
              setSnackbarColor("rgba(144, 202, 249,1)");
           
          
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            setNextStep("addAddress",3)
            setSnackbarVisible(false);
           
          },1000)
             }else{
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
             }
                
             
             if(response?.logout){
             
              setResponseMessage("You are Logged Out!!!");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              setTimeout(()=>{
                dispatch({type:"LOGOUT"});
          
              },3000)
              
            }
          /* resetting Login input Fields */
          
              }else{
                setResponseMessage("Something Went Wrong...");
                
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)    }
          
            }).catch(error => {
           
              //popup of error Info
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              console.error(error);
            });
    }
       }
       
   
       return <>
       
   
 
  
  <div className=""><div></div>
         <div   className="" style={{borderRadius: '20px',zIndex:"100",top:"50px",bottom:"0px"}}>
           {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
        <h2 align="center" style={{textTransform:"capitalize"}} >   Add Your Bank Details </h2>
      
 
<div className="" style={{overflowY:"auto",overflowX:"hidden",}}>
  

    <div className="">
    
  
   <div >
    
<div style={{} }>
<div  className="" >
<div  className="ikcraft_login-input-card ">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add Business/Institute  Name </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}}
      placeholder={`Add Business/Institute  Name `} type="text"
  rows={1} name="courseTitle" value={businessName} onChange={(e)=>setBusinessName(e.target.value)} />
 </div>
 </div>

 {currentBusinessType?.display_name?<div className=" " style={{display:"flex",justifyContent:"space-between",padding:"10px",paddingLeft:"15px"}} > 
<h4 align="center" style={{textTransform:"capitalize"}}>
  
 Business Type
  
  </h4>
<label className={"radio-outer"}  style={{borderRadius:"5px",minWidth:"80%", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"-12px",position:"relative"}}>
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",border:"2px solid #f1f1f1" ,background:"#ffffff"}}>
<div className="courseContentItemJustifyContentIcons"  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"2px",position:"relative"}}> 
                                    
<input type={"radio"} 
            className="input-textbox"    checked name={"quizFolderRadio"}  

/>
              <span class={"circle"}></span>                       
                                                                
             
 </div><div className="courseContentItemJustifyContent" style={{display:"flex",justifyContent:"left",marginLeft:"10px",alignItems:"center"}}> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700",}}> 
  {currentBusinessType?.display_name} 
 
      </div><div style={{fontSize:"12px",marginTop:"-10px"}}> {currentBusinessType?.description}</div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  <div></div><div></div><div></div><div>{currentBusinessType?.display_name?<Trash2 onClick={()=>{setNextStep("",1) }} 
   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>:""}</div>
 </div>
 <div></div></div> </label></div>:businessTypeCode? <div className=" " style={{display:"flex",justifyContent:"space-between",padding:"10px",paddingLeft:"15px"}} > 
<h4 align="center" style={{textTransform:"capitalize"}}>
  
 Business Type
  
  </h4>
<label className={"radio-outer"}  style={{borderRadius:"5px",minWidth:"80%", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"-12px",position:"relative"}}>
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",border:"2px solid #f1f1f1" ,background:"#ffffff"}}>
<div className="courseContentItemJustifyContentIcons"  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"2px",position:"relative"}}> 
                                    
<input type={"radio"} 
            className="input-textbox"    checked name={"quizFolderRadio"}  

/>
              <span class={"circle"}></span>                       
                                                                
             
 </div><div className="courseContentItemJustifyContent" style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700",}}> 
  {businessTypeCode} 
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  <div></div><div></div><div></div><div>{businessTypeCode?<Trash2 onClick={()=>{setNextStep("",1) }} 
   onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>:""}</div>
 </div>
 <div></div></div> </label></div>:<div className="" style={{paddingBottom:"0px",marginBottom:"0px",marginTop:"-20px"}}> 
       <div className="" style={{borderRadius:"25px",padding:"5px",}}> 
 <div >  <h2 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Select Business Type </h2></div>
      <div className="gridFiftyFixed" style={{marginBottom:"30px"}}>
      <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setNextStep("",1)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Select
 Business Type </div>    </div>
  </div>
  

 </div>} 
 
 <div  className="formBankDetailsGridTwo">
 <div  className="ikcraft_login-input-card">
     <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add Bank Account Number </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Add Bank Account Number `} type="number"
  rows={1} name="courseTitle" value={bankAccNumber} onChange={(e)=>setBankAccountNo(e.target.value)} />
 </div>
 <div  className="ikcraft_login-input-card">
     <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add Bank IFSC Code </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Add Bank IFSC Code`} type="text"
  rows={1} name="courseTitle" value={bankAccIFSC} onChange={(e)=>setBankIFSC(e.target.value)} />
 </div> </div>
 
 <div  className="formBankDetailsGridTwo">
   <div  className="ikcraft_login-input-card">
      <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add Account Holder Name </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Add Account Holder Name`} type="text"
  rows={1} name="courseTitle" value={userName} onChange={(e)=>setUserName(e.target.value)} />
 </div>
 {currentBusinessType?.pan_required? <div  className="ikcraft_login-input-card">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add PAN Number </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Add PAN Number`} type="text"
  rows={1} name="courseTitle" value={panNo} onChange={(e)=>setPanNo(e.target.value)} />
 </div>:""} {currentBusinessType?.gst_required? <div  className="ikcraft_login-input-card">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Add GST Number </span>
 <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Add GST Number`} type="text"
  rows={1} name="courseTitle" value={gstNo} onChange={(e)=>setGstNo(e.target.value)} />
 </div>:""}
 
</div>
  <div  className="ikcraft_login-input-card">
    <span style={{display:"flex",justifyContent:"left",marginLeft:"10px"}}>Account Holder Email ID </span>
 <input onMouseEnter={handleMouseEnter}  type="email" 
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"15px"}} placeholder={`Account Holder Email ID`} 
  rows={1} name="courseTitle" value={user_email?user_email:userEmail} onChange={(e)=>setUserEmail(e.target.value)} />
 </div>
 </div>

</div>





</div>

<div align="center" className="buttonsRazorpayLA" style={{position:"absolute",left:"0px",right:"0px",bottom:"0px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>setNextStep("",1)}    className=" CoursesPreviewTopBtn"  type="submit"
  style={{position:"relative",border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
 > Back </button>

<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewAccount()}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <><LoadingButton  Load={loader?.status}/> Click To  Create</></button>
</div> 
</div>

     </div><div></div></div>

      <div>
     </div>

    
     
     </>


}
export default AddBankDetails;